var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import styled from 'styled-components';
import { string, node, number } from 'prop-types';
import CheckListItem from './CheckListItem';
var ChecklistWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: #ffffff;\n  padding-left: 1.5rem;\n  display: flex;\n"])));
ChecklistWrapper.displayName = 'CheckListWrapper';
var List = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  columns: 1;\n  margin: 0;\n  padding: 0;\n\n  @media (min-width: 768px) {\n    columns: ", ";\n  }\n"])), function (props) {
  return props.desktopColumns;
});
List.displayName = 'CheckListUl';
var ListRow = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"])));
ListRow.displayName = 'CheckListRow';

var CheckList = function CheckList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$desktopColumns = _ref.desktopColumns,
      desktopColumns = _ref$desktopColumns === void 0 ? 2 : _ref$desktopColumns;
  return /*#__PURE__*/React.createElement(ChecklistWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(List, {
    desktopColumns: desktopColumns
  }, children));
};

CheckList.Item = CheckListItem;
CheckList.propTypes = {
  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Required and consists of everything between opening and closing tags
  */
  children: node.isRequired,

  /**
   Optional and will break up the list into number of columns provided. Defaults to 2.
  */
  desktopColumns: number
};
CheckList.displayName = 'CheckList';
export default CheckList;